module.exports = __webpack_public_path__ + "static/media/laughing-emoji-svgrepo-com.c3f2d299.svg";